<template>
  <div>
    <div class="record1"></div>
    <div class="record2">
      <el-form ref="added" inline size="medium">
        <el-form-item label="企业名称">
          <el-input @keyup.enter.native="search" v-model="query.company_name" placeholder="请输入名称"
            clearable show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="管理者">
          <el-input @keyup.enter.native="search" v-model="query.name_or_phone" placeholder="请输入姓名或手机号"
            clearable show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
            <el-select v-model="query.audit_status" placeholder="请选择状态" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="审核中" value="10"></el-option>
              <el-option label="已通过" value="20"></el-option>
              <el-option label="未通过" value="30"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'auth/query')">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'auth/query')">
          <el-button type="info" icon="el-icon-refresh-left" @click="query.company_name= '';query.name_or_phone='';query.audit_status='';search()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="record3">
      <el-table v-loading='loading' stripe border :data="list" tooltip-effect="dark" style="width: 98%">
        <el-table-column align='center' prop="company_name" label="公司名称"></el-table-column>
        <el-table-column align='center' label="营业执照">
          <template slot-scope="scope">
            <el-image v-if="scope.row.license" @click="imgUrl=scope.row.license;dialogVisible=true"
              style="width: 100px; height: 55px;cursor: pointer;"
              :src="scope.row.license + '?imageMogr2/thumbnail/100x'"
              fit="cover"></el-image>
          </template>
        </el-table-column>
        <el-table-column align='center' prop="name" label="管理者"></el-table-column>
        <el-table-column align='center' prop="phone" label="手机号"></el-table-column>
        <el-table-column align='center' prop="created_at" label="创建时间"></el-table-column>
        <el-table-column align='center' label="认证状态">
          <template slot-scope="scope">
            <span v-if="scope.row.audit_status == 0" style="color: #ffac1c;">待审核</span>
            <span v-if="scope.row.audit_status == 10" style="color: #999;">审核中</span>
            <span v-if="scope.row.audit_status == 20" style="color: #0dcd2e;">已通过</span>
            <span v-if="scope.row.audit_status == 30" style="color: #fa1c1c;">未通过
              <el-popover
                placement="top-start"
                title="未通过原因"
                width="200"
                trigger="hover"
                :content="scope.row.reject_reason">
                <i class="el-icon-question" slot="reference" style="font-size: 16px;cursor: pointer;"></i>
              </el-popover>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align='center'>
          <template slot-scope="scope">
            <template v-if="scope.row.audit_status == 0 || scope.row.audit_status == 10">
              <el-button size="mini" type="warning" v-if="JudgeButton(role_permission,'auth/verify')"
                @click="$refs.verify.show(scope.row)">审核</el-button>
            </template>
            <template  v-else>
              <el-button size="mini" type="primary" v-if="JudgeButton(role_permission,'auth/detail')"
                  @click="$refs.verify.show(scope.row)">详情</el-button>
            </template>
            
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin: 30px auto;text-align: center;" v-if="query.total > 0"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="query.page_limit" layout="total, sizes, prev, pager, next, jumper"
        :total="query.total">
      </el-pagination>
    </div>
    <verifyDialog ref='verify' @success='getList()'></verifyDialog>
    <el-dialog
      title="查看图片"
      :visible.sync="dialogVisible"
      width="40%"
      center
      >
      <img :src="imgUrl" alt="" style="display: block;width: 100%;">
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import userInfoAPI from '@/api/api';
  import verifyDialog from '../components/verifyDialog.vue'
  var that;
  export default {
    components: {
      verifyDialog
    },
    props: {},
    data() {
      return {
        loading: true,
        query: {
          page_limit: 10,
          page: 1,
          company_name: '',
          name_or_phone: '',
          audit_status: '',
          total: 0
        },
        list: [],
        dialogVisible: false,
        imgUrl: '',
      }
    },
    computed: {
      role_permission() {
        return this.$store.getters.role_permission
      }
    },
    watch: {},
    created() {
      that = this;
      if (this.$store.state.cache.cacheCompanyAuthQuery) this.query = this.$store.state.cache.cacheCompanyAuthQuery
      this.getList()
    },
    beforeDestroy() {
      this.$store.commit('CACHE_COMPANYAUTH', this.query)
    },
    methods: {
      handleChange(e) {
        if (e[0]) {
          this.query.area_code = e[0]
          this.query.village_code = e[1] || ''
          if(e[1]){
            that.$refs.area.dropDownVisible = false
          }
        } else {
          this.query.area_code = ''
          this.query.village_code = ''
        }
      },
      handleCategoryChange(e) {
        if (e[0]) {
          this.query.service_category_id = e[0]
          this.query.service_project_id = e[1] || ''
          if(e[1]){
            that.$refs.pro.dropDownVisible = false
          }
        } else {
          this.query.service_category_id = ''
          this.query.service_project_id = ''
        }
      },
      JudgeButton(list, rot) {
        let fal = false;
        list.forEach((i, l) => {
          if (i.path == rot) {
            return fal = true;
          }
        })
        return fal
      },
      submitForm() {
        this.$refs['added'].validate(valid => {
          if (!valid) return
          // TODO 提交表单
        })
      },
      handleExport() {
        this.query.flag = 'export';
        this.getList();
      },
      search() {
        this.loading = true;
        this.query.page = 1;
        this.list = [];
        this.getList()
      },
      handleDelete(row) { //删除
        this.$confirm('此操作将永久删除该记录, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.delActivity(row.id).then(res => {
            if (res.data.code == 0) {
              this.$message.success(res.data.msg)
              this.getList()
            }
          })
        })
      },
      reset(id) { //详情
        this.$router.push({
          path: '/recruitAdd',
          query: {
            id: id,
          }
        })
      },
      getList() {
        this.loading = true
        userInfoAPI.companyList(this.query).then(res => {
          if (res && res.data.code == 0) {
            this.list = res.data.data.list || []
            this.query.total = res.data.data.page.count || 0
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      handleSizeChange(val) {
        this.query.page_limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.query.page = val;
        this.getList();
      }
    }
  }
</script>
<style lang="scss" scoped>
  .record1 {
    height: 20px;
  }

  .record3 {
    margin-left: 20px;
  }

  .record2 .el-form-item {
    margin-left: 20px;
  }
</style>
